import React, { useState } from 'react';

/**
 * Prompt textarea with the saved-prompt shortcut.
 * Mount with `key={versionId}` so the "copied from" note belongs to one version.
 */
export default function PromptFields({ scope, scopeId, templates, prompt, onPromptChange, disabled }) {
  const [appliedTemplate, setAppliedTemplate] = useState('');

  /** Only the text is copied: later edits belong to this report and never reach the template. */
  const applyTemplate = (templateId) => {
    const template = templates.find((item) => item.id === templateId);
    if (!template) return;
    if (prompt.trim() && prompt.trim() !== template.prompt.trim()
      && !window.confirm(`Replace the prompt in this report with “${template.name}”?`)) return;
    onPromptChange(template.prompt);
    setAppliedTemplate(template.name);
  };

  return (
    <>
      <div className="custom-reports-template-row">
        <label className="custom-reports-field" htmlFor={`custom-prompt-template-${scopeId}`}>
          <span>Saved prompt</span>
          <select
            id={`custom-prompt-template-${scopeId}`}
            className="custom-reports-control"
            value=""
            onChange={(e) => applyTemplate(e.target.value)}
            disabled={disabled || templates.length === 0}
          >
            <option value="">{templates.length === 0 ? 'No saved prompts yet' : 'Pick a saved prompt...'}</option>
            {templates.map((template) => (
              <option key={template.id} value={template.id}>{template.name}</option>
            ))}
          </select>
        </label>
        <a className="custom-reports-link custom-reports-template-manage" href="/prompt-templates" target="_blank" rel="noreferrer">
          Manage saved prompts
        </a>
      </div>

      <label className="custom-reports-field" htmlFor={`custom-prompt-text-${scopeId}`}>
        <span>Prompt</span>
        <textarea
          id={`custom-prompt-text-${scopeId}`}
          value={prompt}
          onChange={(e) => onPromptChange(e.target.value)}
          rows={10}
          className="custom-reports-control custom-reports-prompt"
          disabled={disabled}
          placeholder="Paste the full prompt. Put {TRANSCRIPT} where the transcript should go, or leave it out and it is added at the end."
        />
      </label>
      {appliedTemplate && (
        <p className="custom-reports-note">
          Copied from <strong>{appliedTemplate}</strong>. Changes here stay in this report — the saved prompt is untouched.
        </p>
      )}
      <p className="custom-reports-note">
        Use <code>{'{TRANSCRIPT}'}</code> to choose where the transcript lands; without it the transcript is appended after your prompt.
        {scope === 'event' && ' Every selected transcript is passed in as one text, so the prompt analyses them together and returns a single report.'}
        {' '}The JSON holds <code>report_title</code>, the answer under <code>content</code>, and the sessions it used under <code>sources</code>.
      </p>
    </>
  );
}
